import SlideFrame from "./_SlideFrame";
import { Sun } from "lucide-react";

const team = [
  {
    name: "Colin Darke",
    role: "Founder & CEO",
    bio: "Eight years as Chief Compliance Officer and General Counsel at Rocket Loans, where he built the consumer-lending compliance program end-to-end. Senior Advisor to the American Fintech Council. Licensed in Illinois, Michigan, and Massachusetts. LL.M., Banking & Financial Law, Boston University.",
  },
  {
    name: "Senga Rutebuka",
    role: "Chief Growth Officer",
    bio: "Nearly a decade at Rocket Loans across operations, servicing, and senior business strategy. Leads growth and partner strategy at CompliSun — the bridge between our compliance program and partner expansion. Active fintech investor through Bias Capital and VU Venture Partners.",
  },
  {
    name: "Jennifer Green",
    role: "Consulting Counsel",
    bio: "Licensed attorney and compliance consultant with nearly a decade at Bank of America and BNY Mellon covering policy implementation, KYC/AML, FATCA, estate settlement, and third-party risk management. At CompliSun she leads policy reviews, regulatory-change programs, and contract negotiations for financial-services clients.",
  },
  {
    name: "Rana Zouein",
    role: "Legal & Compliance Consultant",
    bio: "Advises fintech, banking, and corporate clients across more than a dozen jurisdictions, with deep expertise in regulatory compliance, licensing, AML/KYC, and data privacy. Prior Legal & Compliance Counsel at GlobeMed Gulf and Saradar Bank. Member, Beirut Bar Association. Works in English, French, Arabic, and Spanish.",
  },
  {
    name: "Li-Chen Hung",
    role: "Compliance Analyst",
    bio: "Owns day-to-day compliance analysis at CompliSun — AML/BSA program implementation, audit coordination, regulatory response management, and Money Transmitter License administration. Previously Compliance Analyst at Align Technology. LL.M., Banking & Financial Law, Boston University School of Law.",
  },
];

export default function SlideComplisunTeam() {
  return (
    <SlideFrame tag="06 · Compliance">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
        <div className="max-w-3xl">
          <p className="overline mb-4 flex items-center gap-3">
            <Sun className="w-4 h-4 text-primary" strokeWidth={1.5} />
            CompliSun · compliance partner
          </p>
          <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium">
            The team running your <em className="italic text-primary">compliance program</em>.
          </h2>
        </div>
        <p className="text-sm text-muted-foreground max-w-sm">
          When you bundle compliance with IBA Servicing, this is who you're getting — not a
          platform with a chatbot. A fractional team with real consumer-finance scars.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-foreground/20 border border-foreground/20">
        {team.map((p) => (
          <article
            key={p.name}
            className="bg-background p-6 md:p-7 flex flex-col min-h-[260px]"
            data-testid={`complisun-person-${p.name.replace(/\s+/g, "-").toLowerCase()}`}
          >
            <header className="mb-4 border-b border-current/10 pb-3">
              <h3 className="font-display text-2xl tracking-tight leading-tight">{p.name}</h3>
              <p className="font-mono-data text-[11px] uppercase tracking-brand mt-1 text-primary">
                {p.role}
              </p>
            </header>
            <p className="text-sm leading-relaxed text-foreground/80">{p.bio}</p>
          </article>
        ))}
        <aside className="bg-muted border-t-4 border-t-primary p-6 md:p-7 flex flex-col justify-between min-h-[260px]">
          <div className="flex items-center gap-3">
            <Sun className="w-5 h-5 text-primary" strokeWidth={1.5} />
            <span className="overline">CompliSun</span>
          </div>
          <div>
            <p className="font-display text-xl md:text-2xl leading-tight text-foreground/90">
              <em className="italic">"We give founders the structure, tools, and guidance to grow without being hindered by regulation."</em>
            </p>
            <p className="mt-4 font-mono-data text-[11px] uppercase tracking-brand text-muted-foreground">
              — CompliSun team
            </p>
          </div>
        </aside>
      </div>

      <p className="mt-8 text-sm text-muted-foreground italic font-display text-xl max-w-3xl">
        Combined, the team carries bar admissions in five U.S. states, LL.M.s in Banking &
        Financial Law, and hands-on tours at Rocket Loans, Bank of America, BNY Mellon,
        Saradar Bank, and the American Fintech Council.
      </p>
    </SlideFrame>
  );
}
